import React from "react";

export default function WaterRepellantIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <defs>
        <path
          id="0hqugclq7a"
          d="M0.493 -0.001L38.493 -0.001 38.493 53.999 0.493 53.999z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    fill="#231F20"
                    d="M.493 71.001L60.493 71.001 60.493 69.001.493 69.001zM.493 65.001L60.493 65.001 60.493 63.001.493 63.001z"
                    transform="translate(-1237 -2618) translate(1138 2598) translate(62 20) translate(37) translate(10 5)"
                  />
                  <path
                    stroke="#231F20"
                    strokeWidth="2"
                    d="M42.493 37c0 5.523-4.478 10-10 10"
                    transform="translate(-1237 -2618) translate(1138 2598) translate(62 20) translate(37) translate(10 5)"
                  />
                  <path
                    fill="#231F20"
                    d="M0 54.602L1.996 55.12 3.991 47.439 11.975 49.513 12.473 47.593 2.493 45.001zM48.493 47.593L48.992 49.514 56.975 47.439 58.971 55.12 60.966 54.602 58.473 45.001z"
                    transform="translate(-1237 -2618) translate(1138 2598) translate(62 20) translate(37) translate(10 5)"
                  />
                  <g>
                    <path
                      fill="#231F20"
                      d="M54.24 46c-4.284 9.986-14.1 17-25.636 17S7.03 55.986 2.747 46H.584c4.387 11.125 15.336 19 28.02 19s23.41-7.875 27.798-19H54.24z"
                      transform="translate(-1237 -2618) translate(1138 2598) translate(62 20) translate(37) translate(10 5) translate(2 .001)"
                    />
                    <g transform="translate(-1237 -2618) translate(1138 2598) translate(62 20) translate(37) translate(10 5) translate(2 .001) translate(9)">
                      <mask id="tum9x8fd5b" fill="#fff">
                        <use xlinkHref="#0hqugclq7a" />
                      </mask>
                      <path
                        fill="#231F20"
                        d="M19.493 51.999c-9.374 0-17-7.626-17-17 0-3.95 1.32-7.658 3.814-10.722l.927-1.458 12.26-19.115 12.258 19.115.927 1.458c2.495 3.064 3.814 6.772 3.814 10.722 0 9.374-7.626 17-17 17m15-29l-15-23-15 23c-2.662 3.27-4 7.455-4 12 0 10.493 8.507 19 19 19s19-8.507 19-19c0-4.545-1.338-8.73-4-12"
                        mask="url(#tum9x8fd5b)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
